<template>
  <div>
    <h3 class="display-4" @click="enableDebug($event)">Extra List</h3>

    <o-list-toolbar
      :filter-classes="classContainer"
      :filters-list="filter_list"
      :search-fields-list="search_field_list"
      :selected-filter="selected_filter"
      :list-options="list_options"
      @reset_table="reset_table"
      @options_changed="update_table($event)"
      @filter_changed="update_filter($event)"
      :schema="schema"
      :query-select-options="options"
      :new-to="{ name: 'service_extra.create', params: { id: 0 } }"
      new-button-text="New Extra"
    >
      <template slot="middle">
        <!-- <o-list-multi-actions
          :schema="schema"
          :selection="selected"
          @delete="doDeleteItems"
          @merge="doMergeItems"
          enable-delete
          enable-merge
        /> -->
      </template>
    </o-list-toolbar>
    <!-- @row-selected="onRowSelected"
      :selectable="selected.selectable" :key="selected.selectable" -->
    <b-table
      striped
      bordered
      :fields="fields"
      :items="items"
      head-variant="light"
      class="o-list extras"
      thead-class="o-gradient-header position-sticky"
      sticky-header="70vh"
      no-local-sorting
      @sort-changed="change_sort"
      :sort-by="list_options.sort"
      :sort-desc="list_options.order === 'desc'"
      :tbody-tr-class="rowClass"
    >
      <template v-slot:cell(_selected)="{ rowSelected }">
        <template v-if="rowSelected">
          <span aria-hidden="true">&check;</span>
          <span class="sr-only">Selected</span>
        </template>
        <template v-else>
          <span aria-hidden="true">&nbsp;</span>
          <span class="sr-only">Not selected</span>
        </template>
      </template>
      <template slot="cell(id)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'id'"
        >
          <default-display :value="item.id"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(active_end_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'active_end_date'"
        >
          <date-display
            :value="item.active_end_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(active_start_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'active_start_date'"
        >
          <date-display
            :value="item.active_start_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(amount)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'amount'"
        >
          <number-display :value="item.amount" :decimals="2" />
        </o-link-cell>
      </template>
      <template slot="cell(quoted_amount)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'quoted_amount'"
        >
          <label v-if="item.quoted_amount">$</label>
          <number-display :value="item.quoted_amount" :decimals="2" />
        </o-link-cell>
      </template>
      <template slot="cell(builder)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'builder'"
        >
          <lookup-display
            :list="optionCustomerItemsById"
            :value="item.builder"
            display-field="name"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(category_of_works)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'category_of_works'"
        >
          <ul style="padding-left: 15px">
            <li
              :key="index"
              v-for="(category, index) in item.category_of_works"
              style="list-style: disc"
            >
              <lookup-display
                :list="optionCodeCategoryOfWorkItemsById"
                :value="category"
                display-field="description"
                default-value="-"
              ></lookup-display>
            </li>
          </ul>
          <template v-if="!item.category_of_works.length">
            <label>-</label>
          </template>
        </o-link-cell>
      </template>
      <template slot="cell(cancelled_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'cancelled_date'"
        >
          <date-display
            :value="item.cancelled_date"
            format="DD/MM/YYYY"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(code)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'code'"
        >
          <default-display :value="item.code"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(completed_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'completed_date'"
        >
          <date-display
            :value="item.completed_date"
            format="DD/MM/YYYY"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(created_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'created_date'"
        >
          <date-display
            :value="item.created_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(description)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'description'"
        >
          <default-display :value="item.description"></default-display>
        </o-link-cell>
      </template>

      <template slot="cell(job)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'job'"
        >
          <default-display :value="item.job"></default-display>
        </o-link-cell>
      </template>
      <template
        slot="cell(maintenance_order_number)"
        slot-scope="{ index, item }"
      >
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'maintenance_order_number'"
        >
          <default-display
            :value="item.maintenance_order_number"
          ></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(modified_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'modified_date'"
        >
          <date-display
            :value="item.modified_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(old_job_no)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'old_job_no'"
        >
          <default-display :value="item.old_job_no"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(purchase_order_number)" slot-scope="{ index, item }">
        <template v-for="(purchase_order, index) in item.purchase_orders">
          <div :key="index">
            <default-display
              :value="
                item.purchase_orders.length > 0 && item.purchase_orders
                  ? index == item.purchase_orders.length - 1
                    ? getPONumber(purchase_order.po_number)
                    : getPONumber(purchase_order.po_number) + '\n'
                  : 'None'
              "
            ></default-display>
          </div>
        </template>
        <template v-if="item.purchase_orders.length <= 0">
          <default-display value="None"></default-display>
        </template>
        <!-- <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'purchase_order_number'"
        >
          <default-display
            :value="item.purchase_order_number"
          ></default-display>
        </o-link-cell> -->
      </template>
      <template slot="cell(repair_files)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'repair_files'"
        >
          <default-display :value="item.repair_files"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(repair_notes)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'repair_notes'"
        >
          <default-display :value="item.repair_notes"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(site_address)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'site_address'"
        >
          <default-display :value="item.site_address"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(suburb)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'suburb'"
        >
          <default-display :value="item.suburb"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(supervisor)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'supervisor'"
        >
          <default-display :value="item.supervisor_name"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(supervisor_name)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'supervisor_name'"
        >
          <default-display :value="item.supervisor_name"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(used_materials)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'used_materials'"
        >
          <default-display :value="item.used_materials"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(audit_trail)" slot-scope="{ index, item }">
        <a
          :href="
            'https://shojun3.qa2.ocom.com.au/static/services.html#/service_extra/history?extraId=' +
            item.id
          "
          target="_blank"
          rel="noopener noreferrer"
          >View</a
        >
        <!-- <o-link-cell
          :to="{
            name: 'service_repair.history',
            params: { repairId: item.id, code: item.code },
          }"
        >
          <default-display value="View"></default-display>
        </o-link-cell> -->
        <!-- <o-link-cell
          :to="{
            name: 'service_repair.history',
            params: { repairId: item.id, code: item.code },
          }"
        >
          <default-display value="View"></default-display>
        </o-link-cell> -->
      </template>

      <template slot="cell(raised_by)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'raised_by'"
        >
          <default-display :value="item.raised_by__name"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(date_raised)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'date_raised'"
        >
          <date-display
            :value="item.date_raised"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(date_raised_quoted)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'date_raised_quoted'"
        >
          <date-display
            :value="item.date_raised_quoted"
            format="DD/MM/YYYY"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(extra_type)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'extra_type'"
        >
          <default-display
            :value="item.extra_type__description"
          ></default-display>
          <!-- <lookup-display
            :list="optionCodeExtraTypeItemsById"
            :value="item.extra_type"
            display-field="description"
            default-value="-"
          ></lookup-display> -->
        </o-link-cell>
      </template>
      <template slot="cell(sub_contractor)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'sub_contractor'"
        >
          <default-display :value="item.sub_contractor__name"></default-display>
        </o-link-cell>
      </template>
      <template
        slot="cell(subcontractor_invoice_amount)"
        slot-scope="{ index, item }"
      >
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'subcontractor_invoice_amount'"
        >
          <number-display
            :value="item.subcontractor_invoice_amount"
            :decimals="2"
          />
        </o-link-cell>
      </template>
      <template slot="cell(customer)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'customer'"
        >
          <default-display :value="item.customer"></default-display>
          <!-- <lookup-display
            :list="optionCustomerItemsById"
            :value="item.customer"
            display-field="name"
            default-value="-"
          ></lookup-display> -->
        </o-link-cell>
      </template>
      <template slot="cell(date_po_requested)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'date_po_requested'"
        >
          <date-display
            :value="item.date_po_requested"
            format="DD/MM/YYYY"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(over_due_po)" slot-scope="{ index, item }">
        <template v-for="(purchase_order, index) in item.purchase_orders">
          <div :key="index">
            <default-display
              :value="
                item.purchase_orders.length > 0 && item.purchase_orders
                  ? index == item.purchase_orders.length - 1
                    ? getOverDuePo(
                        item.date_po_requested,
                        purchase_order.date_po_supplied
                      )
                    : getOverDuePo(
                        item.date_po_requested,
                        purchase_order.date_po_supplied
                      ) + '\n'
                  : 'None'
              "
            ></default-display>
          </div>
        </template>
        <template v-if="item.purchase_orders.length <= 0">
          <default-display value="None"></default-display>
        </template>
        <!-- <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'over_due_po'"
        >
          <number-display :value="getOverDuePo(item.date_po_requested, item.purchase_orders)" :decimals="0" />
        </o-link-cell> -->
      </template>
      <template slot="cell(comments)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'comments'"
        >
          <default-display :value="item.comments"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(date_invoiced)" slot-scope="{ index, item }">
        <template v-for="(purchase_order, index) in item.purchase_orders">
          <div :key="index">
            <default-display
              :value="
                item.purchase_orders.length > 0 && item.purchase_orders
                  ? index == item.purchase_orders.length - 1
                    ? convertDate(purchase_order.date_invoiced)
                    : convertDate(purchase_order.date_invoiced) + '\n'
                  : 'None'
              "
            ></default-display>
          </div>
        </template>
        <template v-if="item.purchase_orders.length <= 0">
          <default-display value="None"></default-display>
        </template>
      </template>
      <template slot="cell(invoice_number)" slot-scope="{ index, item }">
        <template v-for="(purchase_order, index) in item.purchase_orders">
          <div :key="index">
            <default-display
              :value="
                item.purchase_orders.length > 0 && item.purchase_orders
                  ? index == item.purchase_orders.length - 1
                    ? getPONumber(purchase_order.invoice_number)
                    : getPONumber(purchase_order.invoice_number) + '\n'
                  : 'None'
              "
            ></default-display>
          </div>
        </template>
        <template v-if="item.purchase_orders.length <= 0">
          <default-display value="None"></default-display>
        </template>
      </template>
      <template slot="empty">
        <p>
          <emoticon-sad-icon large></emoticon-sad-icon>
        </p>
        No Data Found. Please
        <router-link :to="{ name: 'service_extra.create' }"
          >create a new item</router-link
        >
      </template>
    </b-table>

    <o-list-paging
      :limit="list_options.limit"
      :page-options="rows_per_page_items"
      :offset="list_options.offset"
      :total-items="total_items"
      @change-limit="change_limit"
      @change-page="change_page"
    />
  </div>
</template>

<style></style>

<script>
import {
  CreateCodeTableFetchMixin,
  CreateGroupPermissionMixin,
  CreateListPageMixin,
  MultiActionsMixin,
} from "../../../vue-ocom/mixins";
import {
  fieldToTableColumn,
  GetSearchFields,
} from "../../../vue-ocom/schema/schema_utils";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import schema from "../../schema/index";

import OListToolbar from "../../../vue-ocom/components/list/OListToolbar";
import OListPaging from "../../../vue-ocom/components/list/OListPaging";
import DefaultDisplay from "../../../vue-ocom/components/display/DefaultDisplay";
import DateDisplay from "../../../vue-ocom/components/display/DateDisplay";
import NumberDisplay from "../../../vue-ocom/components/display/NumberDisplay";
import BooleanDisplay from "../../../vue-ocom/components/display/BooleanDisplay";
import LookupDisplay from "../../../vue-ocom/components/display/LookupDisplay";
import EmoticonSadIcon from "vue-material-design-icons/EmoticonSad";
import EmailIcon from "vue-material-design-icons/Email";
import LinkIcon from "vue-material-design-icons/Link";
import moment from "moment";

export default {
  components: {
    EmoticonSadIcon,
    EmailIcon,
    LinkIcon,
    OListPaging,
    OListToolbar,
    DateDisplay,
    DefaultDisplay,
    BooleanDisplay,
    NumberDisplay,
    LookupDisplay,
  },
  mixins: [
    CreateListPageMixin("ServiceExtra", "service_extra"),
    MultiActionsMixin,
    CreateGroupPermissionMixin("ServiceExtra"),
    CreateCodeTableFetchMixin([
      "Customer",
      "Supervisor",
      "Supplier",
      "Employee",
      "CodeCategoryOfWork",
    ]),
  ],
  data: function () {
    return {
      classContainer: "col-xs-12 col-md-4 col-lg-3",
      schemaModel: cleanUpModel(
        schema.ServiceExtra,
        {}
      ) /*Use this.schema instead */,

      search_field_list: GetSearchFields(schema.ServiceExtra),

      filterRow: true /* Set to False to disable filter row */,
      filter_list: [
        { name: "Active", code: "active", options: { offset: 0, sort: "id" } },
        {
          name: "Cancelled",
          code: "cancelled",
          options: { offset: 0, sort: "id" },
        },
        {
          name: "Ready to Invoice",
          code: "ready_to_invoice",
          options: { offset: 0, sort: "id" },
        },
        {
          name: "Waiting for PO",
          code: "waiting_for_po",
          options: { offset: 0, sort: "id" },
        },
        {
          name: "Invoiced",
          code: "invoiced",
          options: { offset: 0, sort: "id" },
        },
        {
          name: "Approve Payment",
          code: "approve_payment",
          options: { offset: 0, sort: "id" },
        },
        {
          name: "PO Not Requested",
          code: "po_not_requested",
          options: { offset: 0, sort: "id" },
        },
        {
          name: "Not Invoiced",
          code: "not_invoiced",
          options: { offset: 0, sort: "id" },
        },
        {
          name: "Send to Customer",
          code: "send_to_customer",
          options: { offset: 0, sort: "id" },
        },
        {
          name: "Work In Progress",
          code: "work_in_progress",
          options: { offset: 0, sort: "id" },
        },

        {
          name: "Declined",
          code: "declined",
          options: { offset: 0, sort: "id" },
        },

        {
          name: "Not Active",
          code: "inactive",
          options: { offset: 0, sort: "id" },
        },
        {
          name: "Completed But Not Invoiced",
          code: "completed_but_not_invoiced",
          options: { offset: 0, sort: "id" },
        },

        {
          name: "Unpaid Invoices",
          code: "unpaid_invoices",
          options: { offset: 0, sort: "id" },
        },
        {
          name: "Completed",
          code: "completed",
          options: { offset: 0, sort: "id" },
        },
        {
          name: "New submissions",
          code: "new_submissions",
          options: { offset: 0, sort: "id" },
        },
        {
          name: "Accepted By Supervisor",
          code: "accepted_by_supervisor",
          options: { offset: 0, sort: "id" },
        },
        {
          name: "Declined By Supervisor",
          code: "declined_by_supervisor",
          options: { offset: 0, sort: "id" },
        },
        {
          name: "Need Approval",
          code: "need_approval",
          options: { offset: 0, sort: "id" },
        },
        {
          name: "All",
          code: "all",
          options: { offset: 0, sort: "job__id", order: "desc" },
        },
      ],

      user_column_selection: null /* If user can customise the columns set them here */,
      column_override_params: {
        /* Put any column overrides here key by fieldname */
        id: { label: "Extra No" },
        code: { label: "Extra Ref No" },
        purchase_order_number: { label: "PO No." },
        job: { label: "Job Number" },
        amount: { label: "Amount (Inc GST)" },
        completed_date: { label: "M.R. Completed Date" },
      },
      table_color: "table-default",
    };
  },
  methods: {
    getOverDuePo(date_po_requested, date_po_supplied) {
      if (date_po_requested) {
        if (date_po_supplied) {
          var given = moment(date_po_requested, "YYYY-MM-DD");
          var current = moment(date_po_supplied, "YYYY-MM-DD");
          let result = moment.duration(current.diff(given)).asDays();
          return isNaN(result) ? "" : result + " days";
        }
        return "0 days";
      }

      return "None";
    },
    getPONumber(ponumber) {
      if (ponumber) {
        return ponumber;
      }
      return "None";
    },
    convertDate(date) {
      if (date) {
        let conDate = moment(date).format("DD/MM/YYYY");
        return conDate;
      }
      return "None";
    },
    changeTableColor(color) {
      this.table_color = color;
    },
    addTdClass(entries) {
      entries.forEach(function (entry) {
        if (entry) {
          entry["tdClass"] = "cell_style";
        }
      });
    },
    cell_style(value, key, item) {
      if (key === "quoted_amount") {
        return "text-right";
      }
      return null;
    },
    rowClass(item, type) {
      return "tr-" + item.service_status;
    },
  },
  computed: {
    checkListOptions() {
      return this.list_options.filter;
    },
    options() {
      return {
        Customer: {
          options: this.optionCustomerItems,
          textField: "name",
          valueField: "id",
        },
        Supervisor: {
          options: this.optionSupervisorItems,
          textField: "name",
          valueField: "id",
        },
        Job: {
          options: this.optionJobItems,
          textField: "description",
          valueField: "id",
        },
        Employee: {
          options: this.optionEmployeeItems,
          textField: "full_name",
          valueField: "id",
        },
      };
    },
    fields() {
      const vm = this;
      const selectedColumns = this.user_column_selection || [
        "code",
        "raised_by",
        "date_raised_quoted",
        "extra_type",
        "category_of_works",
        "sub_contractor",
        "subcontractor_invoice_amount",
        "job__id",
        "builder",
        "site_address",
        "suburb",
        "supervisor",
        "description",
        "quoted_amount",
        "purchase_order_number",
        "over_due_po",
        "date_invoiced",
        "invoice_number",
        "maintenance_order_number",
        "comments",
      ];
      const fields = selectedColumns.map(function (item) {
        return fieldToTableColumn(
          vm.schema,
          item,
          vm.column_override_params[item]
        );
      });

      this.addTdClass(this.filterTableColumns(this.schema, fields));

      return this.addSelectionColums(
        this.filterTableColumns(this.schema, fields)
      );
    },
    first_column_key() {
      if (this.fields) {
        return this.fields[0].key;
      } else {
        return null;
      }
    },
  },
};
</script>

<style>
.h-a {
  height: auto;
}
.w-20 {
  width: 15% !important;
  margin-left: 20px;
}
.w-10 {
  margin-left: 20px;
}
.extras .tr-unknown {
  background-color: white;
}
.extras .tr-cancelled {
  text-decoration: line-through;
  color: red;
}

ul {
  align-items: center;
}
</style>
